export default class {
  constructor() {
    return new window.R.ui.Post("nomination_submission", {
      createUsers: false
    });
  }
}
